import { Pipe, PipeTransform } from '@angular/core';

import { ProgrammingUtilsService } from './../../../common/services/utils.service';
import { ScheduleQuickstartContext } from './../services/schedule.service';

const REPEAT_INTERVALS: Array<string> = [
  '', // for no repeat
  'days',
  'weeks',
  'months',
  'years'
];

const DOW_ABBREVS: Array<string> = [
  'Su',
  'M',
  'Tu',
  'W',
  'Th',
  'F',
  'Sa'
];

const DOW_WEEKEND: number = 65;
const DOW_WEEKDAYS: number = 62;
const DOW_ALL: number = 127;

enum Repeats {
  None = 0,
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
  Yeary = 4
}

@Pipe({
  name: 'repeatLabel'
})
export class RepeatLabelPipe implements PipeTransform {

  constructor(
    private utils: ProgrammingUtilsService
  ) { }

  transform(vm: ScheduleQuickstartContext, args?: any): any {

    let label = '';

    if (vm) {
      if (vm.repeatFrequency !== Repeats.None) {
        label += 'Every ';
        if (vm.repeatRate > 1) {
          label += (vm.repeatRate + ' ');
        }
        label += REPEAT_INTERVALS[vm.repeatFrequency];
        if (vm.repeatRate === 1) {
          // trim the trailing 's' to singuarlize the expression
          label = label.substring(0, label.length - 1);
        }

        if (vm.repeatFrequency === Repeats.Weekly) {
          if (vm.repeatDays > 0) {
            if ((vm.repeatDays & DOW_ALL) !== DOW_ALL) {
              let dow = ' on ';

              // NOTE if it's not all days, then it can only fully match either:
              // weekends or weekdays, or some weird combination of the two
              if ((vm.repeatDays ^ DOW_WEEKEND) === 0) {
                dow += 'weekends';
              } else if ((vm.repeatDays ^ DOW_WEEKDAYS) === 0) {
                dow += 'weekdays';
              } else {
                // some weird combination of days, so let's build the display up from parts
                for (let i = 0; i < DOW_ABBREVS.length; i++) {
                  if (this.utils.bitTest(vm.repeatDays, i)) {
                    dow += (DOW_ABBREVS[i] + ' ');
                  }
                }
              }

              label += dow;
            }
          }
        }
      } else {
        label = 'Occurs once';
      }
    }

    return label;
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-schedule/pipes/repeat-label.pipe.ts